import { ChevronDown } from 'lucide-react';
import { cn } from '@/utils/shad';
import { Button } from '@/comps/primitives/button';
import { WithClassName } from '@/types/component';
import { ButtonHTMLAttributes, forwardRef, ReactNode } from 'react';
import { BasicTooltip } from '@/comps/basic-tooltip';

export type FilterContentV2PillClassNames = {
  label?: string;
  button?: string;
  chevron?: string;
};

type Props = WithClassName &
  Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'className'> & {
    label: string;
    placeholder?: string;
    isPlaceholder?: boolean;
    highlight?: boolean;
    invalid?: boolean;
    hideChevron?: boolean;
    classNames?: FilterContentV2PillClassNames;
    tooltip?: ReactNode;
  };

export const FilterContentV2Pill = forwardRef<HTMLButtonElement, Props>(function FilterContentV2Pill(
  {
    label,
    placeholder,
    disabled,
    isPlaceholder,
    highlight,
    invalid,
    hideChevron,
    className,
    classNames,
    tooltip,
    ...rest
  },
  ref,
) {
  const display = isPlaceholder ? (placeholder ?? label) : label;
  const button = (
    <Button
      ref={ref}
      type="button"
      variant="outline"
      disabled={disabled}
      className={cn(
        'h-7 cursor-pointer justify-between gap-1 rounded-base border-zinc-800 bg-[#09090B] px-2 py-1.5 text-[12px] leading-4 font-semibold opacity-80 hover:bg-zinc-900 disabled:pointer-events-auto disabled:text-foreground',
        className,
        classNames?.button,
        highlight && 'group:border-white border-white!',
        invalid && 'border-negative/60 ring-1 ring-negative/60',
      )}
      {...rest}
    >
      <span className={cn('truncate', isPlaceholder && 'text-muted-foreground', classNames?.label)}>{display}</span>
      {!hideChevron && <ChevronDown className={cn('h-3.5 w-3.5 shrink-0 text-foreground', classNames?.chevron)} />}
    </Button>
  );

  return (
    <BasicTooltip
      text={tooltip}
      show={Boolean(tooltip)}
      side="bottom"
      classNameContent="max-w-sm break-normal! text-wrap wrap-break-word text-start"
    >
      {button}
    </BasicTooltip>
  );
});
